import { Injectable, inject } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Injectable({
  providedIn: 'root',
})
export class Ga4Service {
  // Inyección de dependencias
  private $gaService = inject(GoogleAnalyticsService);

  ga4(event: string) {
    this.$gaService.event(event);
  }
}
